//CHANGE HIDDEN INPUT TO SLUG FOR REDIRECT

$(document).on('change', '#input_4_4', function(event) {
	event.preventDefault();
	var wu_redirect = $(this).find(':selected').attr('data-program');
	console.log(wu_redirect);
	$('#input_4_6').val(wu_redirect);
});
